import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/dm-mono/400.css";
import "@fontsource/dm-mono/500.css";
import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Defer Sentry so it is not on the critical first-paint path.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  const initSentry = () => {
    void import("@sentry/react").then(({ init }) => {
      init({
        dsn: sentryDsn,
        environment: import.meta.env.VITE_ENVIRONMENT,
        tracesSampleRate: 0.1,
      });
    });
  };

  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(initSentry, { timeout: 3000 });
  } else {
    setTimeout(initSentry, 1);
  }
}
